<template>
    <div class="tab-text">
         <section>
            <h1 class="py-5">Bank Transfer</h1>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Bank 1</span>
                    <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <!-- <vs-input
                        class="w-full"
                        v-model="form.bank1"
                    /> -->
                    <vs-select
                        autocomplete
                        @input-change="autoCompleteFunc"
                        class="vx-col sm:w-1/3 w-full"
                        v-model="form.bank1"
                        placeholder="Bank Name"
                    >
                        <vs-select-item
                            :key="index"
                            :value="item.code"
                            :text="item.name"
                            v-for="(item,index) in bankList"
                        />
                    </vs-select>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Account Name</span>
                    <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                        v-validate="{regex: /^[\u0E00-\u0E7FA-Za-z0-9., -]+$/}"
                        name="bankaccname1"
                        class="w-full"
                        v-model="form.bankaccname1"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('bankaccname1')">
                        {{ errors.first("bankaccname1") }}
                    </span>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Account Number</span>
                    <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                        v-validate="{regex: /^([0-9 -]+)$/}"
                        :maxlength="16"
                        name="bankaccno1"
                        class="w-full"
                        v-model="form.bankaccno1"
                        onkeypress="return /^[0-9 -]/i.test(event.key)"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('bankaccno1')">
                        {{ errors.first("bankaccno1") }}
                    </span>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Bank 2</span>
                    <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <!-- <vs-input class="w-full" v-model="form.bank2" /> -->
                    <vs-select
                        autocomplete
                        @input-change="autoCompleteFunc"
                        class="vx-col sm:w-1/3 w-full"
                        v-model="form.bank2"
                        placeholder="Bank Name"
                    >
                        <vs-select-item
                            :key="index"
                            :value="item.code"
                            :text="item.name"
                            v-for="(item,index) in bankList"
                        />
                    </vs-select>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Account Name</span>
                    <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                        v-validate="{regex: /^[\u0E00-\u0E7FA-Za-z0-9., -]+$/}"
                        name="bankaccname2"
                        class="w-full"
                        v-model="form.bankaccname2"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('bankaccname2')">
                        {{ errors.first("bankaccname2") }}
                    </span>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Account Number</span>
                    <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                        v-validate="{regex: /^([0-9 -]+)$/}"
                        :maxlength="16"
                        name="bankaccno2"
                        class="w-full"
                        v-model="form.bankaccno2"
                        onkeypress="return /^[0-9 -]/i.test(event.key)"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('bankaccno2')">
                        {{ errors.first("bankaccno2") }}
                    </span>
                </div>
            </div>
         </section>
         <hr>
         <section class="mt-5">
            <h1 class="py-5">Taxes</h1>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Withholding Tax Deduction</span>
                    <div style="font-size:0.75rem; color:#aaa;">
                        Allows buyers to request Withholding Tax deductions (applicable
                        for orders valued 1000 Baht and above)
                    </div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <ul class="demo-alignment">
                        <li>
                            <vs-radio
                            vs-name="radios-wht_status"
                            v-model="form.wht_status"
                            :vs-value="1"
                            default-value
                            >Enabled</vs-radio
                            >
                        </li>
                        <li>
                            <vs-radio
                            vs-name="radios-wht_status"
                            v-model="form.wht_status"
                            :vs-value="0"
                            >Disabled</vs-radio
                            >
                        </li>
                    </ul>
                </div>
            </div>

            <div class="vx-row mb-6" v-show="form.wht_status == '1'">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Deduction Percentage</span>
                    <div style="font-size:0.75rem; color:#aaa;">
                    Deduction percentage
                    </div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <div class="vx-row mb-6">
                        <div
                            class="vx-col"
                            style="width: 150px;"
                        >
                            <vs-input
                                v-validate="{regex: /^([0-9.]+)$/}"
                                name="wht_vat"
                                class="w-full"
                                v-model="form.wht_vat"
                                onkeypress="return /^[0-9.]/i.test(event.key)"
                            />
                            <span class="text-danger text-sm" v-show="errors.has('wht_vat')">
                                {{ errors.first("wht_vat") }}
                            </span>
                        </div>
                        <div class="vx-col sm:w-2/3" style="padding-top:15px; font-size: 16px;">%</div>
                    </div>
                </div>
            </div>
        </section>
        <hr>
        <section
            class="mt-5"
            v-if="role === 'so-admin'"
        >
            <h1 class="py-5">Advanced</h1>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Allow Credit Card Payment</span>
                    <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <ul class="demo-alignment">
                        <li>
                            <vs-radio
                            vs-name="radios-pay_creditcard"
                            v-model="form.pay_creditcard"
                            :vs-value="1"
                            >Yes</vs-radio
                            >
                        </li>
                        <li>
                            <vs-radio
                            vs-name="radios-pay_creditcard"
                            v-model="form.pay_creditcard"
                            :vs-value="0"
                            >No</vs-radio
                            >
                        </li>
                    </ul>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>Allow Bank Transfer Payment</span>
                    <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <ul class="demo-alignment">
                        <li>
                            <vs-radio
                            vs-name="radios-pay_transfer"
                            v-model="form.pay_transfer"
                            :vs-value="1"
                            >Yes</vs-radio
                            >
                        </li>
                        <li>
                            <vs-radio
                            vs-name="radios-pay_transfer"
                            v-model="form.pay_transfer"
                            :vs-value="0"
                            >No</vs-radio
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <hr/>
        <div style="height:10px;"></div>
        <div class="vx-row pt-5 mt-5">
          <div class="vx-col w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="submitBasic">Submit</vs-button>
            <vs-button v-if="showSellerCancel" class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
          </div>
        </div>
    </div>
</template>

<script>
import Service from "@/services";

import { timezones } from "@/utils/Timezones";

export default {
    props: [ 'form', 'e', 'role' ],
    data() {
        return {
            posterUploadUrl: process.env.VUE_APP_API_URL + "/events/" + this.folder + "/upload",
            posterUploadHeader: {
                Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
            },
            posterData: {
                type: "poster"
            },
            timezones: timezones,
            showSellerCancel: false,
            bankList: [
                {
                    name: 'Kasikorn Bank',
                    code: 'kbank'
                },
                {
                    name: 'Siam Commercial Bank',
                    code: 'scb'
                },
                {
                    name: 'Krungthai Bank',
                    code: 'ktb'
                },
                {
                    name: 'Bank of Ayudhya',
                    code: 'bay'
                },
                {
                    name: 'Bangkok Bank',
                    code: 'bbl'
                }
            ],
        }
    },
    methods: {
        autoCompleteFunc(val) {},
        submitBasic() {
            const path = this.$route.path.includes('/sellers/')
            if (path) {
                this.$emit('submitBasic', this.form)
            }
            else {
                this.$vs.loading();
                const formData = new FormData();
                const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key];
                    formData.append(key, value)
                }
                Service.Event.saveMerchant(formData, this.e)
                    .then(() => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Success",
                            text: "Update complete.",
                            color: "success"
                        });
                    })
                    .catch(() => {
                        this.$vs.loading.close();
                    });
            }
        },
        canceled() {
            this.$router.push('/sellers')
        },
        switchBank1(data) {
            switch (data) {
                case 'kbank'|| 'Kasikorn Bank':
                    this.form.bank1 = 'kbank'
                    return this.form.bank1

                case 'scb' || 'Siam Commercial Bank':
                    this.form.bank1 = 'scb'
                    return this.form.bank1

                case 'ktb' || 'Krungthai Bank':
                    this.form.bank1 = 'ktb'
                    return this.form.bank1

                case 'bay' || 'Bank of Ayudhya':
                    this.form.bank1 = 'bay'
                    return this.form.bank1

                case 'bbl' || 'Bangkok Bank':
                    this.form.bank1 = 'bbl'
                    return this.form.bank1

                default:
                    return
            }
        },
        switchBank2(data) {
            switch (data) {
                case 'kbank' || 'Kasikorn Bank':
                    this.form.bank2 = 'kbank'
                    return this.form.bank2

                 case 'scb' || 'Siam Commercial Bank':
                    this.form.bank2 = 'scb'
                    return this.form.bank2

                case 'ktb' || 'Krungthai Bank':
                    this.form.bank2 = 'scb'
                    return this.form.bank2

                case 'bay' || 'Bank of Ayudhya':
                    this.form.bank2 = 'bay'
                    return this.form.bank2

                case 'bbl' || 'Bangkok Bank':
                    this.form.bank2 = 'bbl'
                    return this.form.bank2

                default:
                    return
            }
        },
        getBank1() {
            if (this.form.bank1.length > 3) {
                const data = this.bankList.find(ele => ele.name === this.form.bank1)
                this.form.bank1 = data.code
            }
        },
        getBank2() {
            if (this.form.bank2.length > 3) {
                const data = this.bankList.find(ele => ele.name === this.form.bank2)
                this.form.bank2 = data.code
            }
        }
    },
    mounted() {
        this.showSellerCancel = this.$route.path.includes('/sellers/') ? true: false
        this.getBank1()
        this.getBank2()
        // this.switchBank1(this.form.bank1)
        // this.switchBank2(this.form.bank2)
    }

};
</script>
